import React from 'react'
import CommingSoon from './CommingSoon'

function NFilms() {
  return (
    <div style={{width:'100vw',overflowX:'hidden'}}><CommingSoon/></div>
  )
}

export default NFilms